import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";

export class ZIDXLandingPage implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxLandingPageContainer";
    }
    render(){
        // console.log("page edit");
    }
}